import React, { useEffect, useMemo } from "react";
import Modal from "react-bootstrap/Modal";
import PropTypes from "prop-types";
import _Button from "../../../generic/_Button";
import BtnExportToExcell from "../../../../utils/BtnExportToExcell";
import Icon from "../../../Icon";
import { classNames } from "../../../../utils/helpers";
import { getStatus } from "../../../../utils/AuxFunctions";
import ModalSkeleton from "../../../ui/Skeleton/ModalSkeleton";
import { NotContent } from "../../../ui/Form";
import { Tooltip } from ".././../../ui/Tooltip";
import { FormatInt } from "../../../../utils/FormatData";
import { useCampaignMessageErrors } from "../../../../features/campaigns/details/hooks/useCampaignMessageErrors";
import { useCampaignMessageSummary } from "../../../../features/campaigns/details/hooks/useCampaignMessageSummary";
import { useDownloadCampaignReport } from "../../../../features/campaigns/details/hooks/useDownloadCampaignReport";
import CampaignDetailPdfDocument from "../../../../features/campaigns/details/components/CampaignDetailPdfDocument";
import { PDFDownloadLink } from "@react-pdf/renderer";
import { getCampaignDetailReportData } from "../../../../features/campaigns/details/utils/campaignDetailReportData";
const BadgeStatus = ({ idStatus }) => {
  return (
    <div
      className={classNames(
        "rounded-lg px-3 py-1 flex items-center justify-between",
        {
          "bg-gray-100": idStatus == 1,
          "bg-yellow-100": idStatus == 2,
          "bg-green-100": idStatus == 3,
          "bg-red-100": idStatus == 4,
        }
      )}
    >
      <div
        className={classNames("w-2 h-2 rounded-full mx-2", {
          "bg-gray-700": idStatus == 1,
          "bg-yellow-700": idStatus == 2,
          "bg-green-700": idStatus == 3,
          "bg-red-700": idStatus == 4,
        })}
      ></div>
      <span
        className={classNames("text-sm font-semibold", {
          "text-gray-700": idStatus == 1,
          "text-yellow-700": idStatus == 2,
          "text-green-700": idStatus == 3,
          "text-red-700": idStatus == 4,
        })}
      >
        {getStatus(idStatus)}
      </span>
    </div>
  );
};

const DetailRow = ({ label, value, alt }) => {
  const isNumeric =
    typeof value === "number" ||
    (typeof value === "string" &&
      value.trim() !== "" &&
      /^-?\d+(\.\d+)?$/.test(value));
  return (
    <div
      className={`flex justify-between px-4 py-1.5 ${
        alt ? "bg-gray-200" : ""
      } hover:bg-gray-300 `}
    >
      <div className="text-sm font-semibold text-gray-500">{label}</div>
      <div className="text-md font-semibold">
        {!isNumeric ? value : FormatInt(value)}
      </div>
    </div>
  );
};

const DetailCampaignRcs = (props) => {
  const {
    data,
    refreshData,
    nameCampaign,
    idStatus,
    type = "sms",
    onDownloadReport = () => {},
    isLoadingReport = false,
  } = props;
  const { cards, details, percentage, sent, total } = useMemo(
    () => getCampaignDetailReportData({ data, type }),
    [data, type]
  );

  const DOWNLOAD_CONFIG = {
    Respuestas: {
      type: "replies",
      message: "Descargar reporte de respuestas",
    },
    Acciones: {
      type: "actions",
      message: "Descargar reporte de acciones",
    },
    Rechazados: {
      type: "rejects",
      message: "Descargar reporte de rechazados",
    },
  };

  return (
    <>
      <div className="flex justify-between">
        <_Button
          icon="refresh"
          title="Actualizar"
          onClick={refreshData}
          style="none"
        />
        <BadgeStatus idStatus={idStatus} />
      </div>
      <div className="flex flex-col w-full py-2">
        <div className="w-full grid grid-cols-2 gap-1 py-1">
          {cards.map((card, index) => {
            return (
              <div className="rounded-lg px-4 py-2 bg-gray-100" key={index}>
                <div className="flex justify-between">
                  <div className="flex justify-start items-center gap-2">
                    <Icon icon={card.icon} className={card.color} size={30} />
                    <div>
                      <div className="text-3xl font-semibold">
                        {FormatInt(card.value)}
                      </div>
                      <div className="text-sm font-semibold text-gray-700">
                        {card.title}
                      </div>
                    </div>
                  </div>

                  {card.value > 0 && DOWNLOAD_CONFIG[card.title] && (
                    <Tooltip message={DOWNLOAD_CONFIG[card.title].message}>
                      <span
                        className="material-symbols-outlined cursor-pointer"
                        onClick={() =>
                          onDownloadReport?.(DOWNLOAD_CONFIG[card.title].type)
                        }
                        disabled={isLoadingReport}
                      >
                        download
                      </span>
                    </Tooltip>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </div>

      <div className="flex flex-col w-full px-4 py-2 bg-gray-100 rounded-lg">
        <div className="text-md font-semibold">Mensaje de campaña</div>
        <div className="text-[12px] font-semibold">{nameCampaign || "---"}</div>
      </div>
      <div className="bg-gray-100 rounded-lg px-4 py-2 my-2">
        <div className="flex flex-col w-full px-2 space-y-2">
          <div className="flex justify-between">
            <div className="text-sm font-semibold">Progreso</div>
            <div className="text-sm font-semibold">{percentage ?? 0} %</div>
          </div>

          <div className="w-full bg-gray-300 rounded-full">
            <div
              className="bg-green-500 h-2.5 rounded-full"
              style={{
                width: `${Math.max(0, Math.min(percentage, 100))}%`,
              }}
            ></div>
          </div>
          <div className="flex justify-between my-1">
            <div className="text-sm font-semibold">
              {FormatInt(sent)} Enviados
            </div>

            <div className="text-sm font-semibold">
              {FormatInt(total)} Total
            </div>
          </div>
        </div>
      </div>
      <div className="flex flex-col w-full px-4 py-2 bg-gray-100 rounded-lg">
        <div className="flex justify-start">
          <div className="text-md font-semibold">Detalles</div>
        </div>

        {details.map((item, index) => (
          <DetailRow
            key={index}
            label={item.label}
            value={item.value ?? 0}
            alt={index % 2 === 0}
          />
        ))}
      </div>
    </>
  );
};
const _ModalDetail = (props) => {
  const { visible, onClose, title = "", data, isEmail = false, type } = props;
  const { uidCampaign, idCampaignMessage, idStatus, nameCampaign } = data || {};

  const _onClose = () => {
    if (onClose) onClose();
  };

  const { mutate: GetErrorsCampaignMessage, data: messageErrors = [] } =
    useCampaignMessageErrors();

  const { mutate: downloadReports, isPending: isLoadingReport } =
    useDownloadCampaignReport({
      uidCampaign,
      idCampaignMessage,
    });

  const {
    isPending: isLoading,
    mutate: GetSummmaryCampaignMessage,
    data: messageSummary = [],
  } = useCampaignMessageSummary();

  const getSummaryParams = useMemo(
    () => ({
      uidCampaign,
      idCampaignMessage,
      isEmail,
      type,
    }),
    [uidCampaign, idCampaignMessage, isEmail, type]
  );

  const getErrorsParams = useMemo(
    () => ({
      uidCampaign,
      idCampaignMessage,
    }),
    [uidCampaign, idCampaignMessage]
  );

  useEffect(() => {
    if (visible) {
      GetSummmaryCampaignMessage(getSummaryParams);
      GetErrorsCampaignMessage(getErrorsParams);
    }
  }, [
    visible,
    GetSummmaryCampaignMessage,
    GetErrorsCampaignMessage,
    getSummaryParams,
    getErrorsParams,
  ]);

  const renderDetails = () => {
    if (isLoading) return <ModalSkeleton />;

    if (!messageSummary || messageSummary.length === 0)
      return (
        <NotContent
          description={"Parece que aun no hay información para mostrar"}
        />
      );

    return (
      <DetailCampaignRcs
        idStatus={idStatus}
        data={messageSummary}
        refreshData={() => GetSummmaryCampaignMessage(getSummaryParams)}
        nameCampaign={nameCampaign}
        type={type}
        onDownloadReport={downloadReports}
        isLoadingReport={isLoadingReport}
      />
    );
  };

  return (
    <Modal show={visible} onHide={_onClose} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title>
          <div className="flex items-center gap-2 justify-between">
            <div className="text-xl font-semibold text-gray-600">{title}</div>
            <div
              className={classNames("px-2 py-1 rounded-lg", {
                "bg-purple-100": type === "rcs",
                "bg-blue-100": type == "sms",
              })}
            >
              <div className="uppercase text-gray-600">{type}</div>
            </div>
          </div>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {renderDetails()}
        {messageErrors && messageErrors.length > 0 && (
          <BtnExportToExcell
            dataReport={messageErrors}
            fileName={"Errors campaña"}
            label="Detalle de Errores"
          />
        )}
      </Modal.Body>
    <Modal.Footer className="sticky bottom-0 bg-white">
        <PDFDownloadLink
          className="btn btn-primary"
          document={
            <CampaignDetailPdfDocument
              title={title}
              type={type}
              idStatus={idStatus}
              nameCampaign={nameCampaign}
              data={messageSummary}
            />
          }
          fileName={`Detalle_Campaña_${uidCampaign}.pdf`}
        >
          Descargar PDF
        </PDFDownloadLink>
        <_Button title="Cerrar" style="none" onClick={_onClose} />
      </Modal.Footer>
    </Modal>
  );
};

_ModalDetail.propTypes = {
  visible: PropTypes.bool,
  onClose: PropTypes.func,
  title: PropTypes.string,
  data: PropTypes.object,
  isEmail: PropTypes.bool,
  type: PropTypes.string,
};

BadgeStatus.propTypes = {
  idStatus: PropTypes.number,
};

DetailCampaignRcs.propTypes = {
  idStatus: PropTypes.number,
  data: PropTypes.object,
  refreshData: PropTypes.func,
  nameCampaign: PropTypes.string,
  type: PropTypes.string,
  onDownloadReport: PropTypes.func,
  isLoadingReport: PropTypes.bool,
};

DetailRow.propTypes = {
  label: PropTypes.string,
  value: PropTypes.string,
  alt: PropTypes.bool,
};
export default _ModalDetail;
